import React from 'react';
import niceScrollbars from './niceScrollBars';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './modalStyle';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

export const BookModal = ({
  children,
  title,
  subtitle,
  open,
  setOpen,
  formik,
  maxWidth = false,
  fullWidth = false,
}) => {
  const classes = useStyles();
  const handleClose = () => {
    if (formik) {
      formik.handleReset();
    }

    setOpen(false);
  };
  return (
    <Dialog
      className={classes.dialogRoot}
      PaperProps={{
        sx: { borderRadius: 4, ...niceScrollbars },
      }}

      onClose={handleClose}
      open={Boolean(open)}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle>
        <Box display='flex'>
          <Box flex={1}>
            <Typography variant='h5' sx={{ fontWeight: 500 }}>
              {title}
            </Typography>
            <Typography
              variant='body2'
              sx={{ fontSize: '0.75rem', fontWeight: 500, color: '#737384' }}
            >
              {subtitle}
            </Typography>
          </Box>
          <IconButton onClick={handleClose} sx={{ color: '#ccc' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={niceScrollbars}>{children}</DialogContent>
    </Dialog>
  );
};
